// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pWmPak4hT_W73mOBhZQc{display:flex;color:var(--primary-color-gray-1)}.pWmPak4hT_W73mOBhZQc:hover{color:var(--primary-color-black)}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Button/IconBtn/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,iCAAA,CACA,4BACE,gCAAA","sourcesContent":[".icon{\n  display: flex;\n  color: var(--primary-color-gray-1);\n  &:hover{\n    color: var(--primary-color-black);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `pWmPak4hT_W73mOBhZQc`
};
export default ___CSS_LOADER_EXPORT___;
